<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Add Subslide</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-autocomplete
        v-model="select"
        :filter="v => v"
        :items="items"
        :loading="loading"
        :search-input.sync="search"
        box
        item-text="name"
        item-value="_id"
        label="Search for Main Slide"
        placeholder="Start typing to Search"
        return-object
      />
      <v-img v-if="select" :src="select.asset.png" class="preview" />
      <div v-if="select">
        <p>{{ select.externalId }} &middot; {{ select.name }}</p>
      </div>
    </v-container>
    <v-card-actions>
      <v-spacer />
      <v-btn depressed @click="$emit('close')">
        Close
      </v-btn>
      <v-btn :disabled="!canSubmit" depressed @click="submit">
        Assign
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// import SlideService from '@/services/modules/slide';
import { SLIDE_ASSIGN_SUBSLIDE } from '@/config/constants';

export default {
  name: 'AssignSlideDialog',
  props: {
    parentId: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      select: null,
      search: null,
      items: [],
      canSubmit: false
    };
  },
  watch: {
    search(val) {
      val && val !== this.select && this.query(val);
    },
    select(selected) {
      if (selected) {
        this.canSubmit = true;
      }
    }
  },
  methods: {
    query(val) {
      this.loading = true;
      const { SlideService } = require('@/services/modules/slide');
      new SlideService()
        .queryByNameAndId(val)
        .then(result => {
          this.items = result.data.filter(i => {
            return (
              i.productId === this.$store.state.product.selected.product._id &&
              i.country === this.$store.state.product.selected.country &&
              this.parentId !== i._id
            );
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      if (!this.select) return;
      this.loading = true;
      this.$store.dispatch(SLIDE_ASSIGN_SUBSLIDE, { id: this.parentId, subId: this.select._id }).then(() => {
        this.select = null;
        this.items = [];
        this.search = null;
        this.canSubmit = false;
        this.loading = false;
        this.$emit('close');
      });
    }
  }
};
</script>

<style scoped>
.preview {
  border: 1px solid var(--light-form-bg);
}
</style>
